import React, { useState } from "react";
import StepShell from "./StepShell";
import { errorMessage } from "./apiError";

export default function DeclineScreen({ onSend }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function send() {
    setError("");
    setBusy(true);
    try {
      await onSend(reason.trim() || null);
    } catch (err) {
      setError(errorMessage(err));
      setBusy(false);
    }
  }

  return (
    <StepShell
      question="What didn't work for you?"
      subtitle="Optional. It helps us send better matches."
      action={{ label: "Send", onClick: send, busy, busyLabel: "Sending…" }}
    >
      <textarea
        id="decline-reason"
        aria-label="What didn't work"
        rows={4}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder="e.g. lane too long, rate too low, wrong equipment"
        className="w-full resize-y rounded-2xl border-2 border-slate-300 bg-white px-4 py-3 font-[Roboto] text-[17px] text-slate-900 focus:border-indigo-600 focus:outline-none focus:ring-4 focus:ring-indigo-100"
      />
      {error && (
        <p className="m-0 font-[Roboto] text-[15px] text-red-700">{error}</p>
      )}
    </StepShell>
  );
}
